import calculateStrength from './calculateStrength';
import { getColor } from 'core/utils/Styles';

const getBarProps = value => {
	const badColor = getColor('salmon');
	const goodColor = getColor('mountainMeadow');
	const pwProps = {};

	let pwStrength = calculateStrength(value);

	if (value.length && pwStrength === 0) {
		pwStrength = 1;
	}

	switch (pwStrength) {
		case 0:
			pwProps.width = 0;
			pwProps.fill = badColor;
			break;

		case 1:
			pwProps.width = 25;
			pwProps.fill = badColor;
			break;

		case 2:
			pwProps.width = 50;
			pwProps.fill = goodColor;
			break;

		case 3:
			pwProps.width = 75;
			pwProps.fill = goodColor;
			break;

		default:
			pwProps.width = 100;
			pwProps.fill = goodColor;
	}

	return pwProps;
};

export default getBarProps;
